import React, { useState, useEffect, useCallback } from 'react';
import InfiniteScroll from 'react-infinite-scroll-component';
import _ from 'lodash';
import { Stack, Box, Button, useMediaQuery, useTheme } from '@mui/material';
import AutoCompleteSelectUI from '../Interface/AutoCompleteSelectUI';
import TodoCard from './TodoCard';
import simpletaskService from '../../service/simpletask.service';
import { useLoader } from '../../provider/LoaderProvider';
import { generateFilter } from '../../utils/helper';
import useMenus from '../../context/MenuContext';
import useParam from '../../context/ParamContext';
import useUsers from '../../context/UsersContext';
import { DebouncedInputUI, FormLabelUI } from '../Interface';
import EmployeeAttendanceDialog from '../EmployeeAttendance/EmployeeAttendanceDialog';
import SimpleTaskDialog from './SimpleTaskDialog';
import TodoFilters from './TodoFilters';
import CommentDialog from '../Comment/CommentDialog';
import SimpleTaskAttachmentDialog from '../NewSimpleTask/SimpleTaskAttachmentDialog';

const TodoContent = ({
  activeTab,
  type,
  tabId,
  autoCompleteOptions,
  formValState,
  prioValue,
  changed,
  handleOpenAddTaskDialog,
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const { formVal, setFormVal } = formValState;
  const { taskChanged, setTaskChanged } = changed;
  const { getUser, user } = useUsers();
  const { params } = useParam();
  const { menus, getMenus, getMenuSubMenuId } = useMenus();
  const [submenu, setSubmenu] = useState(null);
  const [myTodo, setMyTodo] = useState([]);
  const [query, setQuery] = useState({
    filter: [],
    sorting: {
      sortModel: [{ field: 'startDate', sort: 'desc' }],
    },
    pagination: {
      paginationModel: {
        pageSize: 20,
        page: 0,
      },
    },
  });

  const [showEmployeeAttendanceDialog, setShowEmployeeAttendanceDialog] = useState({ open: false, data: {} });
  const [taskDialogData, setTaskDialogData] = useState({ open: false, data: {} });
  const [filterAnchorEl, setFilterAnchorEl] = useState(null);
  const [defaultFilterFields, setDefaultFilterFields] = useState([]);
  const [hasMore, setHasMore] = useState(true);
  //@TODO user a contextből
  const userObj = JSON.parse(localStorage.getItem('user'));
  const announctedTaskStatus = params.MYTODO_ANNOUNCED_TASK_STATUS
    ? parseInt(params.MYTODO_ANNOUNCED_TASK_STATUS)
    : null;

  const defCommentDialogData = {
    open: false,
    lineId: null,
    subMenuUrl: '',
  };
  const [commentDialogData, setCommentDialogData] = useState(defCommentDialogData);

  const defAttachmentDialog = {
    open: false,
    attachments: [],
    simpleTaskId: null,
  };
  const [attachmentDialog, setAttachmentDialog] = useState(defAttachmentDialog);

  const { showLoader, hideLoader } = useLoader();

  const conditions = {
    like: ['simpleTaskName'],
    gte: ['startDate'],
    lte: ['endDate'],
  };

  useEffect(() => {
    getMenus();
    if (!Object.keys(user).length) getUser();
  }, []);

  useEffect(() => {
    setSubmenu(getMenuSubMenuId('simpleTask'));
  }, [menus]);

  useEffect(() => {
    if (!taskChanged) return;

    setMyTodo([]);

    setQuery((prev) => ({
      ...prev,
      pagination: {
        ...prev.pagination,
        paginationModel: {
          ...prev.pagination.paginationModel,
          page: 0,
        },
      },
    }));
  }, [taskChanged]);

  useEffect(() => {
    const newFields = [
      {
        field: 'deletedBy',
        value: null,
      },
    ];

    if (type === 'own') {
      newFields.push({ field: 'resposiblePersonId', value: userObj.userId });
    } else if (type === 'opened') {
      newFields.push({ field: 'resposiblePersonId', value: null });
      if (announctedTaskStatus) {
        newFields.push({ field: 'statusId', value: announctedTaskStatus });
      }
      //@TODO telephely, szerep stb majd itt kell kezelni
    }

    setDefaultFilterFields(newFields);
  }, [activeTab]);

  useEffect(() => {
    if (defaultFilterFields.length > 0) {
      //@TODO átnézni
      const newStatus = formVal.statusId.map((sIds) => sIds.value);
      const newFormVal = { ...formVal, statusId: newStatus };
      const newFilter = generateFilter(newFormVal, conditions);
      if (!_.isEqual(query.filter, [...defaultFilterFields, ...newFilter])) {
        setMyTodo([]);

        setQuery((prev) => ({
          ...prev,
          filter: [...defaultFilterFields, ...newFilter],
          pagination: {
            ...prev.pagination,
            paginationModel: { ...prev.pagination.paginationModel, page: 0 },
          },
        }));
      }
    }
  }, [formVal, defaultFilterFields]);

  const getList = useCallback(() => {
    showLoader();
    simpletaskService
      .getTasks(query)
      .then((data) => {
        if (query.pagination.paginationModel.page === 0) {
          setMyTodo(data.rows);
        } else {
          setMyTodo((prev) => [...prev, ...data.rows]);
        }
        setHasMore(myTodo.length + data.rows.length < data.rowCount);
        setTaskChanged(false);
      })
      .finally(() => {
        hideLoader();
      });
  }, [query]);

  useEffect(() => {
    if (Object.keys(query).length > 0 && activeTab === tabId && query.filter?.length > 0) {
      //itt kell eldönteni, hogy lapozás, vagy filter válotozott
      getList();
    }
  }, [query, activeTab, tabId, getList]);

  const fetchMoreData = () => {
    setQuery((prev) => ({
      ...prev,
      pagination: {
        paginationModel: {
          ...prev.pagination.paginationModel,
          page: prev.pagination.paginationModel.page + 1,
        },
      },
    }));
  };

  const getTaskById = async (id) => {
    setTaskDialogData((prev) => ({
      ...prev,
      open: true,
    }));
    simpletaskService.getTaskById(id).then((data) => {
      setTaskDialogData((prev) => ({
        ...prev,
        data,
      }));
    });
  };

  return (
    <>
      {!isMobile && (
        <TodoFilters
          formValState={{ formVal, setFormVal }}
          autoCompleteOptions={autoCompleteOptions}
          prioValue={prioValue}
          handleOpenAddTaskDialog={handleOpenAddTaskDialog}
          showAddButton
        />
      )}
      <InfiniteScroll
        dataLength={myTodo.length}
        next={fetchMoreData}
        hasMore={hasMore}
        endMessage={
          <div className="flex justify-center">
            <p className="text-xl">Az összes feladatot megtekintette.</p>
          </div>
        }
      >
        <Stack direction="row" py={{ xs: 1, md: 3 }} flexWrap="wrap" gap={2} justifyContent="center">
          {myTodo.map((task, id) => {
            return (
              <TodoCard
                key={id}
                task={task}
                setMyTodo={setMyTodo}
                submenu={submenu}
                user={user}
                announctedTaskStatus={announctedTaskStatus}
                setShowEmployeeAttendanceDialog={setShowEmployeeAttendanceDialog}
                getTaskById={getTaskById}
                autoCompleteOptions={autoCompleteOptions}
                setCommentDialogData={setCommentDialogData}
                setAttachmentDialog={setAttachmentDialog}
              />
            );
          })}
        </Stack>
      </InfiniteScroll>

      {showEmployeeAttendanceDialog.open && (
        <EmployeeAttendanceDialog
          dialogData={showEmployeeAttendanceDialog}
          onClose={() => setShowEmployeeAttendanceDialog({ open: false, data: {} })}
        />
      )}

      <SimpleTaskDialog
        dialogData={taskDialogData}
        handleClose={() => setTaskDialogData({ open: false, data: {} })}
        changed={{ taskChanged, setTaskChanged }}
      />

      <CommentDialog
        dialogData={commentDialogData}
        handleClose={() => setCommentDialogData(defCommentDialogData)}
        setRefetchTable={setTaskChanged}
      />

      <SimpleTaskAttachmentDialog
        dialogData={attachmentDialog}
        handleClose={() => setAttachmentDialog(defAttachmentDialog)}
        setRefetch={setTaskChanged}
      />
    </>
  );
};

export default TodoContent;
